var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('check-in-editor',{attrs:{"employees":_vm.employees,"logged-in-employee":_vm.loggedInEmployee,"templates":_vm.templates,"isSaving":_vm.isSaving},on:{"save":_vm.onSave,"cancel":_vm.onCancel}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }